import { isAxiosError } from "axios";

const PAST_DUE_LOCKED_PLATFORM_ERROR = "platform_locked_past_due";

export const isPastDueLockedPlatformError = (error: unknown) => {
  return (
    isAxiosError(error) &&
    error.response?.status === 401 &&
    error.response.data?.error === PAST_DUE_LOCKED_PLATFORM_ERROR
  );
};

/**
 * react-query `throwOnError` predicate for Ageless queries mounted in the shared admin
 * shell (sidebar widgets, layout providers, login-redirect loaders). While a platform is
 * Day-30 dunning-locked, those queries 401 with `platform_locked_past_due` on every page of
 * a dual-product platform; letting that reach the router ErrorBoundary redirects the whole
 * SPA to /past-due-locked and walls the practice out of the RepeatMD admin it still pays
 * for. Shell widgets degrade to their empty state instead. Ageless module pages keep the
 * default boundary behavior so the paywall still owns the walled surface.
 */
export const throwToErrorBoundaryUnlessPastDueLocked = (error: unknown): boolean =>
  !isPastDueLockedPlatformError(error);
